import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import actionTypes from './constants';
import combineReducers from './Reducers';

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  combineReducers,
  {},
  composeEnhancer(applyMiddleware(thunk))
);

// Hydrate auth state from localStorage immediately so all pages
// have the user available on first render without per-component workarounds.
try {
  const raw = localStorage.getItem('userObject');

  if (raw) {
    const userObject = JSON.parse(raw);

    if (userObject?.uuid) {
      store.dispatch({ type: actionTypes.SIGN_IN_USER, payload: userObject });
    }
  }
}
catch { /* ignore parse errors */ }

export default store;
